module.exports = __webpack_public_path__ + "img/mh.2b38544d.png";